import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { IntlProvider as ReactIntlProvider } from 'react-intl';
import { getMessages, defaultLocale } from '../utils/i18n';

const LocaleContext = createContext({});

export const useLocaleNew = () => {
  const context = useContext(LocaleContext);
  if (!context) {
    throw new Error('useLocale deve ser usado dentro de um IntlProvider');
  }
  return context;
};

export const IntlProvider = ({ children, initialLocale = defaultLocale }) => {
  const [locale, setLocale] = useState(initialLocale);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const { hostname } = window.location;

      if (hostname === 'www.bringeraircargo.com.br') {
        setLocale('pt-BR');
      }

      const storedLocale = localStorage.getItem('user-locale');
      if (storedLocale && storedLocale !== initialLocale) {
        setLocale(storedLocale);
      }
    }
  }, [initialLocale]);

  const changeLocale = (newLocale: string) => {
    setLocale(newLocale);
    if (typeof window !== 'undefined') {
      localStorage.setItem('user-locale', newLocale);
    }

    // Optional: Update attribute lang on <html> tag
    if (typeof document !== 'undefined') {
      document.documentElement.lang = newLocale;
    }

    // Optional: Callback to notification that lang is changed
    console.log(`Language is changed to ${newLocale}`);
  };

  const contextValue = useMemo(() => {
    return { locale, changeLocale };
  }, [locale]);

  return (
    <LocaleContext.Provider value={contextValue}>
      <ReactIntlProvider
        locale={locale}
        messages={getMessages(locale)}
        defaultLocale={defaultLocale}
      >
        {children}
      </ReactIntlProvider>
    </LocaleContext.Provider>
  );
};
